/*
 *
 * TutorialTour
 *
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer } from 'utils/injectReducer';
import { createStructuredSelector } from 'reselect';
import reducer from './reducer';
import { RootState } from './types';
// @ts-ignore
import Tour from 'kewproj20-reactour';
import {
  onBeforeCloseTutorial,
  tutorialSteps,
} from 'containers/TutorialTour/steps';
import { displayTutorialAction } from 'containers/TutorialTour/actions';
import {
  makeSelectStepTutorialTour,
  selectDisplayTutorialTour,
} from 'containers/TutorialTour/selectors';
import './style.css';
import { theme } from 'styles/styled-components';
import { useTranslation } from 'react-i18next';
import {
  makeSelectActiveTab,
  makeSelectDisplayedTab,
} from '../Header/selectors';
import TabNames from '../Header/TabNames';

interface StateProps {
  isOpen: boolean;
  activeTab: TabNames;
  displayedTab: TabNames;
  activeStep: number;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  isOpen: selectDisplayTutorialTour(),
  activeTab: makeSelectActiveTab(),
  activeStep: makeSelectStepTutorialTour(),
  displayedTab: makeSelectDisplayedTab(),
});

function TutorialTour() {
  useInjectReducer({ key: 'tutorialTour', reducer: reducer });
  const dispatch = useDispatch();
  const { isOpen, activeTab, activeStep, displayedTab } = useSelector(
    stateSelector,
  );
  const { t } = useTranslation();

  const onRequestCloseTutorial = () => {
    dispatch(displayTutorialAction(false));
  };

  return (
    <Tour
      steps={tutorialSteps(dispatch, activeTab, t)}
      isOpen={isOpen && activeTab === displayedTab}
      onRequestClose={onRequestCloseTutorial}
      onBeforeClose={onBeforeCloseTutorial}
      highlightedMaskClassName="active-tuto-step"
      closeWithMask={false}
      maskClassName="tuto-mask"
      className="tuto-message"
      accentColor={theme.ternary}
      scrollDuration={500}
      goToStep={activeStep}
    />
  );
}

export default TutorialTour;
